var _g, _g2, _path, _g3, _path2, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTchRev(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 680,
    height: 300,
    viewBox: "0 0 179.92 79.375",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -217.63)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(100.73 85.623)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(106.59 42.396)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.90311 0 0 .90311 -200.79 123.03)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h24v24h-24z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12 4-1.41 1.41 5.58 5.59h-12.17v2h12.17l-5.58 5.59 1.41 1.41 8-8z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.619 0 0 1.619 -181.38 114.44)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h24v24h-24z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19 3h-14.01c-1.11 0-1.98 0.89-1.98 2l-0.01 14c0 1.1 0.88 2 1.99 2h14.01c1.1 0 2-0.9 2-2v-14c0-1.11-0.9-2-2-2zm0 12h-4c0 1.66-1.35 3-3 3s-3-1.34-3-3h-4.01v-10h14.01z",
    fill: "#dd5858"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.4139 0 0 2.4139 -140.43 111.05)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h24v24h-24z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.10961 0 0 .10961 -155.07 -19.353)",
    d: "m1524.2 180.92-64.736 35.311 31.891 17.395c-2.336 4.8118-3.6484 10.215-3.6484 15.926 0 20.163 16.332 36.492 36.494 36.492 20.163 0 36.494-16.33 36.494-36.492 0-5.7115-1.3136-11.115-3.6504-15.928l20.123-10.977v40.666h11.77v-47.082zm0 123.37c-24.359 0-72.986 12.224-72.986 36.492v18.246h145.97v-18.246c0-24.268-48.627-36.492-72.986-36.492z",
    fill: "#d65fce",
    strokeWidth: 9.1233
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-494.69 -228.75)",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 426.81,
    cy: 382.94,
    r: 2.1167,
    style: {
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 433.63,
    cy: 382.94,
    r: 2.1167,
    style: {
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 440.46,
    cy: 382.94,
    r: 2.1167,
    style: {
      paintOrder: "normal"
    }
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.98317 0 0 .98317 -191.48 141.48)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m12 12.75c1.63 0 3.07 0.39 4.24 0.9 1.08 0.48 1.76 1.56 1.76 2.73v1.62h-12v-1.61c0-1.18 0.68-2.26 1.76-2.73 1.17-0.52 2.61-0.91 4.24-0.91z",
    fill: "#dd5858"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#c64141"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m4 13c1.1 0 2-0.9 2-2s-0.9-2-2-2-2 0.9-2 2 0.9 2 2 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.13 14.1c-0.37-0.06-0.74-0.1-1.13-0.1-0.99 0-1.93 0.21-2.78 0.58-0.74 0.32-1.22 1.04-1.22 1.85v1.57h4.5v-1.61c0-0.83 0.23-1.61 0.63-2.29z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20 13c1.1 0 2-0.9 2-2s-0.9-2-2-2-2 0.9-2 2 0.9 2 2 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24 16.43c0-0.81-0.48-1.53-1.22-1.85-0.85-0.37-1.79-0.58-2.78-0.58-0.39 0-0.76 0.04-1.13 0.1 0.4 0.68 0.63 1.46 0.63 2.29v1.61h4.5z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m12 6c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3z",
    fill: "#dd5858"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-454.63 -237.71)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 368.49,
    y: 335.76,
    width: 49.138,
    height: 18.391,
    ry: 9.1957,
    fill: "#e18cdc",
    fillRule: "evenodd",
    style: {
      paintOrder: "normal"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m365.8 359.28c7.6296-7.4485 6.011-11.685 6.011-11.685l8.7412 6.2863s-4.9075 2.865-14.752 5.3986z",
    fill: "#e18cdc"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.26458 0 0 .26458 375.7 341.78)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h24v24h-24z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0h24v24h-24z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 12,17.27 18.18,21 16.54,13.97 22,9.24 14.81,8.63 12,2 9.19,8.63 2,9.24 7.46,13.97 5.82,21 Z",
    fill: "#8c2586"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.26458 0 0 .26458 382.79 341.78)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h24v24h-24z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0h24v24h-24z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 12,17.27 18.18,21 16.54,13.97 22,9.24 14.81,8.63 12,2 9.19,8.63 2,9.24 7.46,13.97 5.82,21 Z",
    fill: "#8c2586"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.26458 0 0 .26458 389.89 341.78)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h24v24h-24z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0h24v24h-24z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 12,17.27 18.18,21 16.54,13.97 22,9.24 14.81,8.63 12,2 9.19,8.63 2,9.24 7.46,13.97 5.82,21 Z",
    fill: "#8c2586"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.26458 0 0 .26458 396.98 341.78)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h24v24h-24z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0h24v24h-24z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 12,17.27 18.18,21 16.54,13.97 22,9.24 14.81,8.63 12,2 9.19,8.63 2,9.24 7.46,13.97 5.82,21 Z",
    fill: "#8c2586"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.26458 0 0 .26458 404.08 341.78)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h24v24h-24z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0h24v24h-24z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 12,17.27 18.18,21 16.54,13.97 22,9.24 14.81,8.63 12,2 9.19,8.63 2,9.24 7.46,13.97 5.82,21 Z",
    fill: "#f8e6f8"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-453.84 -212.85)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 368.49,
    y: 335.76,
    width: 49.138,
    height: 18.391,
    ry: 9.1957,
    fill: "#e18cdc",
    fillRule: "evenodd",
    style: {
      paintOrder: "normal"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m365.8 359.28c7.6296-7.4485 6.011-11.685 6.011-11.685l8.7412 6.2863s-4.9075 2.865-14.752 5.3986z",
    fill: "#e18cdc"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.26458 0 0 .26458 375.7 341.78)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h24v24h-24z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0h24v24h-24z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 12,17.27 18.18,21 16.54,13.97 22,9.24 14.81,8.63 12,2 9.19,8.63 2,9.24 7.46,13.97 5.82,21 Z",
    fill: "#8c2586"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.26458 0 0 .26458 382.79 341.78)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h24v24h-24z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0h24v24h-24z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 12,17.27 18.18,21 16.54,13.97 22,9.24 14.81,8.63 12,2 9.19,8.63 2,9.24 7.46,13.97 5.82,21 Z",
    fill: "#8c2586"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.26458 0 0 .26458 389.89 341.78)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h24v24h-24z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0h24v24h-24z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 12,17.27 18.18,21 16.54,13.97 22,9.24 14.81,8.63 12,2 9.19,8.63 2,9.24 7.46,13.97 5.82,21 Z",
    fill: "#8c2586"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.26458 0 0 .26458 396.98 341.78)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h24v24h-24z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0h24v24h-24z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 12,17.27 18.18,21 16.54,13.97 22,9.24 14.81,8.63 12,2 9.19,8.63 2,9.24 7.46,13.97 5.82,21 Z",
    fill: "#f8e6f8"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.26458 0 0 .26458 404.08 341.78)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h24v24h-24z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0h24v24h-24z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 12,17.27 18.18,21 16.54,13.97 22,9.24 14.81,8.63 12,2 9.19,8.63 2,9.24 7.46,13.97 5.82,21 Z",
    fill: "#f8e6f8"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTchRev);
export default __webpack_public_path__ + "static/media/tch-rev.3887a110c446d53be118bfadd7859d0e.svg";
export { ForwardRef as ReactComponent };